import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
TableRow.defaultProps = {
    hover: false,
    selected: false,
};
/**
 * moaui Styled Table Row
 *
 * @param {StyledProps} props - children, hover, selected
 * @example
 * <TableRow
 * 	id=""
 * 	hover={true || false}
 * 	selected={true || false}
 * >
 * 	{children}
 * </TableRow>
 * @returns React.ReactElement
 */
export default function TableRow(props) { return (_jsx(StyledComponent, __assign({}, props))); }
;
